module.exports = __webpack_public_path__ + "img/gb.db68882c.svg";